import React from 'react';
import { useSelector } from 'react-redux';

const Skeleton = () => {
  const showUiSkeleton = useSelector(
    (state: any) => state.workflow.flowDefiningAttributes?.showUiSkeleton
  );

  if (!showUiSkeleton) return null;

  return (
    <div className="RXC_STEP tw-step-skeleton tw-z-50 tw-absolute tw-top-0 tw-left-0 tw-min-h-full tw-min-w-full tw-bg-BaseWhite tw-px-4 tw-pt-2 lg:tw-px-10 lg:tw-pt-4 tw-flex tw-flex-col tw-gap-4 tw-overflow-hidden">
      <div className="tw-h-10 tw-w-full"></div>
      <div className="tw-skeleton tw-h-9 tw-w-7/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
      <div className="tw-skeleton tw-h-6 tw-w-9/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
      <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-4">
        <div className="tw-skeleton-card tw-h-32 tw-w-full tw-rounded-md tw-border">
          <div className="tw-flex tw-gap-4 tw-p-4 tw-items-center">
            <div className="tw-skeleton tw-flex-shrink-0 tw-h-24 tw-w-24 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
            <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
              <div className="tw-skeleton tw-h-4 tw-w-3/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
              <div className="tw-skeleton tw-h-4 tw-w-9/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
              <div className="tw-skeleton tw-h-4 tw-w-7/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
            </div>
          </div>
        </div>
        <div className="tw-skeleton-card tw-h-32 tw-w-full tw-rounded-md tw-border">
          <div className="tw-flex tw-gap-4 tw-p-4 tw-items-center">
            <div className="tw-skeleton tw-flex-shrink-0 tw-h-24 tw-w-24 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
            <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
              <div className="tw-skeleton tw-h-4 tw-w-3/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
              <div className="tw-skeleton tw-h-4 tw-w-9/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
              <div className="tw-skeleton tw-h-4 tw-w-7/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
            </div>
          </div>
        </div>
        <div className="tw-skeleton-card tw-h-32 tw-w-full tw-rounded-md tw-border">
          <div className="tw-flex tw-gap-4 tw-p-4 tw-items-center">
            <div className="tw-skeleton tw-flex-shrink-0 tw-h-24 tw-w-24 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
            <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
              <div className="tw-skeleton tw-h-4 tw-w-3/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
              <div className="tw-skeleton tw-h-4 tw-w-9/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
              <div className="tw-skeleton tw-h-4 tw-w-7/12 tw-rounded-full tw-bg-gradient-to-r tw-from-gray-100 tw-to-gray-300"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
